import { useEffect, useRef, useState } from 'react'

import { useSession } from '@marketplace-web/shared/session-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { followBrandEvent } from '@marketplace-web/personalization/follow-brand-data'
import { useAuthModal } from '@marketplace-web/auth-flow/auth-modal-context-feature'
import { toggleBrandFollow } from '@marketplace-web/personalization/brands-data'

type Props = {
  brandId: number
  isFollowed: boolean
}

const useFollowBrand = ({ brandId, isFollowed: initialIsFollowed }: Props) => {
  const isLoggedIn = Boolean(useSession().user)
  const [isFollowed, setIsFollowed] = useState(initialIsFollowed)
  const { track } = useTracking()
  const isLoading = useRef(false)
  const { openAuthModal } = useAuthModal()

  useEffect(() => {
    setIsFollowed(initialIsFollowed)
  }, [initialIsFollowed])

  function signIn() {
    openAuthModal()
  }

  async function toggle() {
    if (isLoading.current) return

    isLoading.current = true
    const response = await toggleBrandFollow({ brandId })
    isLoading.current = false

    if ('errors' in response) return

    const isFollowEvent = response.is_followed

    track(followBrandEvent({ brandId, isFollowEvent }))
    setIsFollowed(isFollowEvent)
  }

  return {
    isFollowed,
    toggleFollow: isLoggedIn ? toggle : signIn,
  }
}

export default useFollowBrand
